var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-modal',{attrs:{"title":"加入批次","width":"800px","maskClosable":false},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.data,"row-selection":{
    selectedRowKeys: _vm.selectedRowKeys, onChange: _vm.onChangeData, onSelect: _vm.onSelect, onSelectAll: _vm.onSelectAll,
  },"rowKey":"batchNo","pagination":_vm.pagination}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }